import { render, staticRenderFns } from "./BuyBoxBundle.vue?vue&type=template&id=eab7765e&scoped=true&"
import script from "./BuyBoxBundle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BuyBoxBundle.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BuyBoxBundle.vue?vue&type=style&index=0&id=eab7765e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab7765e",
  null
  
)

export default component.exports